import type { Language } from '../i18n/useI18n';

type LocalizedAsset = {
  webp: string;
  png: string;
};

type UseCaseAsset = LocalizedAsset & {
  altKey: string;
};

const localized = <T extends string>(folder: T, name: T, language: Language): LocalizedAsset => ({
  webp: `/assets/website/${folder}/ddproof-${name}-${language}-v1.webp`,
  png: `/assets/website/${folder}/ddproof-${name}-${language}-v1.png`,
});

export const heroAssets = {
  get(language: Language) {
    return localized('hero', 'hero-main', language);
  },
};

export const privacyAssets = {
  get(language: Language) {
    return localized('privacy', 'privacy', language);
  },
};

export const reportAssets = {
  get(language: Language) {
    return localized('report', 'report', language);
  },
};

export const socialAssets = {
  get(language: Language) {
    return localized('social', 'og-main', language);
  },
};

export const trustVisualAsset: LocalizedAsset = {
  webp: '/assets/website/trust/ddproof-trust-layers-v1.webp',
  png: '/assets/website/trust/ddproof-trust-layers-v1.png',
};

export const useCaseAssets: Record<string, UseCaseAsset> = {
  rental: {
    webp: '/assets/website/use-cases/ddproof-usecase-rental-v1.webp',
    png: '/assets/website/use-cases/ddproof-usecase-rental-v1.png',
    altKey: 'useCases.rental.alt',
  },
  delivery: {
    webp: '/assets/website/use-cases/ddproof-usecase-delivery-v1.webp',
    png: '/assets/website/use-cases/ddproof-usecase-delivery-v1.png',
    altKey: 'useCases.delivery.alt',
  },
  insurance: {
    webp: '/assets/website/use-cases/ddproof-usecase-insurance-v1.webp',
    png: '/assets/website/use-cases/ddproof-usecase-insurance-v1.png',
    altKey: 'useCases.insurance.alt',
  },
  repair: {
    webp: '/assets/website/use-cases/ddproof-usecase-repair-v1.webp',
    png: '/assets/website/use-cases/ddproof-usecase-repair-v1.png',
    altKey: 'useCases.repair.alt',
  },
  inventory: {
    webp: '/assets/website/use-cases/ddproof-usecase-inventory-v1.webp',
    png: '/assets/website/use-cases/ddproof-usecase-inventory-v1.png',
    altKey: 'useCases.inventory.alt',
  },
  reports: {
    webp: '/assets/website/use-cases/ddproof-usecase-inspection-v1.webp',
    png: '/assets/website/use-cases/ddproof-usecase-inspection-v1.png',
    altKey: 'useCases.reports.alt',
  },
};
